import React from "react";
import styles from "./styles.module.css";
import ArrowRight from "./icons/arrowRight";
import ArrowLeft from "./icons/arrowLeft";

const NavigationArrows = ({ isPrev, isNext, prev, next }) => {
  return (
    <div className={styles.arrows}>
      {isPrev ? (
        <button className={styles.buttonArrowActiveFirst} onClick={prev}>
          <ArrowLeft color={"#000"} />
        </button>
      ) : (
        <button className={styles.buttonSlideDisabled} disabled>
          <ArrowLeft color={"#a6a6a6"} />
        </button>
      )}
      {isNext ? (
        <button className={styles.buttonSlideActive} onClick={next}>
          <ArrowRight color={"#000"} className={styles.buttonArrowActive} />
        </button>
      ) : (
        <button className={styles.buttonSlideDisabledLastSlide} disabled>
          <ArrowRight color={"#a6a6a6"} />{" "}
        </button>
      )}
    </div>
  );
};

export default NavigationArrows;
